import { Box, Button, Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { initSearchFilterData } from "./initData"
import ComboBox from "components/ComboBox"
import { subcontractExpenseApiNm, subcontractInvoiceColNm, subcontractJobColNm } from "constants/subcontractConstant"
import CheckboxFormControl from "components/CheckboxFormControl"
import SearchButton from "components/buttons/SearchButton"
import DateTimeSelect from "components/DateTimeSelect"
import { addIdForDataGrid, addNoDuplicate } from "utils"
import { jobOrderSearchColumns } from "./columns"
import ClearButton from "components/buttons/ClearButton"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { PostAddRounded } from "resource/muiImport"
import DailyJobDialogV3 from "pages/Menu1/DailyJob/DailyJobDialogV3"
import { UserContext } from "contexts/UserContext"
import { ACC_TYP_EMP, ACC_TYP_SUB } from "constants/accountConstant"

let selectedJobOrdId = null

const SearchSubcontractExpenseDialog = ({ setJobOrdTable, dialogOpen, setDialogOpen }) => {

  const { user } = useContext(UserContext)
  const { ax, msData } = useContext(GlobalStateContext)
  const [filterData, setFilterData] = useState({ ...initSearchFilterData })
  const [dataTable, setDataTable] = useState([])
  const [dialogJobOrderOpen, setDialogJobOrderOpen] = useState(false)


  const searchJobOrder = useCallback(() => {
    const postData = {
      ...filterData,
      ContNos: filterData.ContNos?.trim() ? filterData.ContNos.split('\n').map(c => c.trim()).filter(c => c) : null,
      JobOrdIds: filterData.JobOrdIds?.trim() ? filterData.JobOrdIds.split('\n').map(c => c.trim()).filter(c => c).filter(c => !isNaN(c)).map(c => Number(c)) : null
    }

    if(user.AccTypId === ACC_TYP_SUB){
      postData.IsNoScInvId = 0
      postData.IsOnlyScJobOrder = 1
    }
    ax.post(subcontractExpenseApiNm.getSubcontractExpenseJobOrderV2, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "JobOrdId"))
      }
    })
  }, [ax, filterData, user.AccTypId])

  const filterProp = useCallback((name) => ({
    size: "small",
    varaint: "outlined",
    label: subcontractInvoiceColNm[name],
    sx: { width: 150 },
    value: filterData[name] || "",
    onKeyUp: e => { if (e.code === "Enter" || e.code === "NumpadEnter") { searchJobOrder() } },
    onChange: (e) => { setFilterData(oldState => ({ ...oldState, [name]: e.target.value || null })) }
  }), [filterData, searchJobOrder])

  const handleClearFilter = useCallback(() => {
    setFilterData({ ...initSearchFilterData })
  }, [])

  const handleAddAllJobOrder = useCallback(() => {
    setJobOrdTable(o => {
      const result = [...o]
      const mergedData = addNoDuplicate(result, dataTable, "JobOrdId")
      return addIdForDataGrid(mergedData, "JobOrdId")
    })
  }, [dataTable, setJobOrdTable])

  const handleDialogOk = useCallback(() => {
    handleAddAllJobOrder()
    setDialogOpen(false)
  }, [handleAddAllJobOrder, setDialogOpen])

  const handleCellClick = useCallback(({ id, field }) => {
    selectedJobOrdId = id
    if (field === "ShowDetail") {
      setDialogJobOrderOpen(true)
    } else if (field === "Add") {
      setJobOrdTable(o => {
        const result = [...o]
        const item = dataTable.find(d => d.JobOrdId === id)
        const mergedData = addNoDuplicate(result, [item], "JobOrdId")
        return addIdForDataGrid(mergedData, "JobOrdId")
      })
    }
  }, [dataTable, setJobOrdTable])

  const onDailyJobDialogFinish = useCallback(() => {
    searchJobOrder()
  }, [searchJobOrder])

  useEffect(() => {
    if (!dialogOpen) {
      setFilterData({ ...initSearchFilterData })
      setDataTable([])
    }
  }, [dialogOpen, ax])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
      PaperProps={{ sx: { height: 700 } }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค้นหาใบงาน"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1, height: "100%" }} >
          <BoxFR sx={{ alignItems: "flex-start" }}>
            <BoxFC sx={{ gap: 1 }}>
              {user.AccTypId === ACC_TYP_EMP ?
                <ComboBox sx={{ width: 230 }} options={msData.subContractCombo} label={subcontractJobColNm.ScId}
                  selectedId={filterData.ScId}
                  setSelectedId={(id) => setFilterData(o => ({ ...o, ScId: id }))}
                />
                : null}
              <DateTimeSelect
                sx={{ width: 230 }}
                label="วันที่นัดเข้าโรงงาน"
                start={filterData.AptTmSt}
                end={filterData.AptTmEn}
                setSelectDate={(start, end) => { setFilterData(o => ({ ...o, AptTmSt: start, AptTmEn: end })) }}
              />
              {user.AccTypId === ACC_TYP_EMP ?
                <CheckboxFormControl label="เฉพาะงานไม่มีใบแจ้งหนี้"
                  checked={filterData.IsNoScInvId === 1 ? true : false}
                  onChange={(e) => setFilterData(o => ({ ...o, IsNoScInvId: e.target.checked ? 1 : 0 }))} />
                : null
              }


            </BoxFC>
            <BoxFC sx={{ gap: 1 }}>
              <TextField {...filterProp("JobNo")} sx={{ width: 230 }} />
              <TextField {...filterProp("Bkg")} sx={{ width: 230 }} />
              {user.AccTypId === ACC_TYP_EMP ?
                <CheckboxFormControl label="เฉพาะงานรถร่วมรับผิดชอบ"
                  checked={filterData.IsOnlyScJobOrder === 1 ? true : false}
                  onChange={(e) => setFilterData(o => ({ ...o, IsOnlyScJobOrder: e.target.checked ? 1 : 0 }))} />
                : null}
            </BoxFC>
            <TextField {...filterProp("JobOrdIds")} label="เลขที่ใบงาน" type="number" multiline rows={4.5} onKeyUp={null} />
            <TextField {...filterProp("ContNos")} label="หมายเลขตู้" multiline rows={4.5} onKeyUp={null} />
            <BoxFC sx={{ gap: 1 }} height="100%">
              <SearchButton onClick={searchJobOrder} sx={{ width: 180 }} />
              <Box flex={1} />
              <Button variant="contained" onClick={handleAddAllJobOrder} sx={{ width: 180 }}><PostAddRounded sx={{ mr: 1 }} /> เพิ่มใบงานทั้งหมด</Button>
            </BoxFC>
            <ClearButton onClick={handleClearFilter} sx={{ width: 150 }} />

          </BoxFR>
          {/* <Button variant="contained" sx={{ minWidth: 0 }} onClick={fn.searchJobOrder}><AddCircleOutlineRoundedIcon /></Button> */}
          <Box flex={1} >
            <DataGridCellExpand
              hideFooter
              hideToolbar
              rows={dataTable}
              columns={jobOrderSearchColumns}
              onCellClick={handleCellClick}
            />
          </Box>
          {user.AccTypId === ACC_TYP_EMP ?
            <DailyJobDialogV3
              selectedId={selectedJobOrdId}
              dialogOpen={dialogJobOrderOpen}
              setDialogOpen={setDialogJobOrderOpen}
              onFinish={onDailyJobDialogFinish}
            />
            : null}
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="ใช้ข้อมูลทั้งหมดและปิดหน้าต่าง" cancelText="ปิด"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(SearchSubcontractExpenseDialog)